<script setup>
import RankingFansTop3 from '@/components/Ranking/RankingFans/RankingFansTop3.vue'
import RankingFansList from '@/components/Ranking/RankingFans/RankingFansList.vue'
import RankingFansCurrentUser from '@/components/Ranking/RankingFans/RankingFansCurrentUser.vue'
</script>

<template>
  <RankingFansTop3/>

  <RankingFansList class="mt-8"/>

  <RankingFansCurrentUser class="fixed bottom-18 left-0 right-0 z-10"/>
</template>
